import { AuthPageLayout } from '@/components/layouts';
import { MfaVerifyForm } from '@/pages/MfaVerify/MfaVerifyForm';

export const MfaVerify = () => (
  <AuthPageLayout>
    <MfaVerifyForm />
  </AuthPageLayout>
);
